import { NAME_SPACE as ns } from './constants';

export const extra = '';
export const SET_ASSET_DETAILS = `${ns}_SET_ASSET_DETAILS`;
